
export default {
	props: {
		gameId: {
			type: Number,
			requried: true
		},
		goodsCatalogueId: {
			type: Number,
			requried: true
		},
		gameConfig: {
			type: Array,
			default: () => []
		},
		filter: {
			type: Object,
			requried: true
		},
        serverTree: {
            type: Array,
            default: () => []
        },
	},
	data() {
		return {
			showMore: {
				serverLevel1: false,
				serverLevel2: false,
				serverLevel3: false
			},
			optListShowMore: {
				serverLevel1: false,
				serverLevel2: false,
				serverLevel3: false
			}
		}
	},
	watch: {
		serverLevel1: {
			handler: function (list) {
				if (process.client && list.length) {
					const itemHeight = 30
					this.$nextTick(() => {
						const el = this.$refs.optList_serverLevel1
						if (el) {
							this.optListShowMore.serverLevel1 = el.scrollHeight > itemHeight
						}
					})
				}
			},
			immediate: true,
			deep: true
		},
		serverLevel2: {
			handler: function (list) {
				if (process.client && list.length) {
					const itemHeight = 30
					this.$nextTick(() => {
						const el = this.$refs.optList_serverLevel2
						if (el) {
							this.optListShowMore.serverLevel2 = el.scrollHeight > itemHeight
						}
					})
				}
			},
			immediate: true,
			deep: true
		},
		serverLevel3: {
			handler: function (list) {
				if (process.client && list.length) {
					const itemHeight = 30
					this.$nextTick(() => {
						const el = this.$refs.optList_serverLevel3
						if (el) {
							this.optListShowMore.serverLevel3 = el.scrollHeight > itemHeight
						}
					})
				}
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		serverTreeConfig() {
			const result = []
			const _this = this
			function fillServerTreeConfig(serverArr) {
				if (!serverArr || !serverArr.length) return
				for (let i = 0; i < serverArr.length; i++) {
					if (result.length === 3) break
					const item = serverArr[i]
					const target = _this.gameConfig.find(config => config.mappingField === item.mappingField)
					if (target) {
						const isExist = result.some(item => item.mappingField === target.mappingField)
						if (!isExist) result.push(target)
					}
					if (item.children) fillServerTreeConfig(item.children)
				}
			}
			fillServerTreeConfig(this.serverTree)
			return result
		},
		serverLevel1() {
			return [{ id: undefined, name: `全部` }, ...(this.serverTree || [])]
		},
		serverLevel2() {
			const target = this.serverLevel1.find(item => item.id === this.filter[this.serverTreeConfig[0]?.mappingField])
			return [{ id: undefined, name: `全部` }, ...(target?.children || [])]
		},
		serverLevel2More() {
			if (process.client) {
			}
		},
		serverLevel3() {
			const target = this.serverLevel2.find(item => item.id === this.filter[this.serverTreeConfig[1]?.mappingField])
			return [{ id: undefined, name: `全部` }, ...(target?.children || [])]
		}
	},
	methods: {
        // 获取选中的区服数据
        getSelectedServerData(filter) {
            const selectedServers = []
            this.serverTreeConfig.forEach(item => {
                const id = filter[item.mappingField]
                if (id) {
                    // 查找对应的服务器信息
                    const findServer = serverList => {
                        for (const server of serverList) {
                            if (server.id === id) {
                                return {
                                    id: server.id,
                                    name: server.name,
                                    mappingField: item.mappingField,
                                    propertyName: item.propertyName
                                }
                            }
                            if (server.children) {
                                const found = findServer(server.children)
                                if (found)
                                    return found
                            }
                        }
                        return null
                    }
                    const foundServer = findServer(this.serverTree)
                    if (foundServer) {
                        selectedServers.push(foundServer)
                    }
                }
            })
            return selectedServers
        },
		onSelectServer(id, serverIndex) {
			const temp = { ...this.filter }
			this.serverTreeConfig.forEach((item, index) => {
				if (index === serverIndex) {
					temp[item.mappingField] = id
				} else if (index > serverIndex) {
					temp[item.mappingField] = undefined
				}
			})
			this.$emit('update:filter', temp)
			this.$emit('search')
            // 获取选中的区服数据，参考 quick.vue 的逻辑
	        const selectedServerData = this.getSelectedServerData(temp)
		    this.$emit('change', 'server', selectedServerData)
		},
		watchHandler(level) {
			return function (list) {
				if (process.client && list.length) {
					const itemHeight = 30
					this.$nextTick(() => {
						const el = this.$refs[`optList_${level}`]
						this.optListShowMore[level] = el.scrollHeight > itemHeight
					})
				}
			}
		}
	},
}
